export function addShadowDomSupportToTurbolinks(Turbolinks) {
  Turbolinks.Controller.prototype.clickBubbled = function clickBubbled(event) {
    let { target } = event;

    const composedPath = event.composedPath();
    const inSlot = composedPath.find(e => e.tagName === 'SLOT');

    if (target.shadowRoot || inSlot) {
      /**
       * https://github.com/turbolinks/turbolinks/blob/v5.2.0/src/turbolinks/controller.coffee#L222
       *
       * Selector copied from original Turbolinks
       */
      const elements = composedPath.filter(e =>
        e.matches?.('a[href]:not([target]):not([download])')
      );

      // eslint-disable-next-line prefer-destructuring
      target = elements[0] || target;
    }

    let action;
    let link;
    let location;
    if (this.enabled && this.clickEventIsSignificant(event)) {
      // eslint-disable-next-line no-cond-assign
      if ((link = this.getVisitableLinkForNode(target))) {
        // eslint-disable-next-line no-cond-assign
        if ((location = this.getVisitableLocationForLink(link))) {
          if (this.applicationAllowsFollowingLinkToLocation(link, location)) {
            event.preventDefault();
            action = this.getActionForLink(link);
            return this.visit(location, {
              action,
            });
          }
        }
      }
    }
  };
  Turbolinks.shadowDomSupport = true;
}

export default addShadowDomSupportToTurbolinks;
